import Vue from 'vue'
import App from './app.vue'

import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import iip from './plugins/iip'

import '@/styles/main.scss'

Vue.config.productionTip = false

//filters.install(Vue)
Vue.use(iip)

new Vue({
  router,
  store,
  vuetify,
  created: async () => {
    await store.dispatch('theme/setTheme')
  },
  render: (h) => h(App)
}).$mount('#app')
